(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./CodeDetailsHeading.module.css";

const CodeDetailsHeading = _ref => {
  let {
    showDescription,
    taxes,
    description,
    isRtl,
    isUseActionAvailable
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDetailsHeading, {
      [styles.rtl]: isRtl
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.codeDetailsTitle
  }, showDescription && description), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDetailsTax, {
      [styles.isUseActionAvailable]: isUseActionAvailable
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.taxes, {
      [styles.rtl]: isRtl
    })
  }, taxes === null || taxes === void 0 ? void 0 : taxes.map(tax => /*#__PURE__*/React.createElement("div", {
    className: styles.codeDetailsTaxItem,
    key: tax.tax
  }, t(tax.tax)))), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.codeDetailsTaxUom, {
      [styles.rtl]: isRtl
    })
  }, t("UOM"))));
};

__signature__(CodeDetailsHeading, "useTranslation{{ t }}", () => [useTranslation]);

CodeDetailsHeading.propTypes = {
  showDescription: PropTypes.bool,
  taxes: PropTypes.array,
  description: PropTypes.string,
  isRtl: PropTypes.bool,
  isUseActionAvailable: PropTypes.bool
};
CodeDetailsHeading.defaultProps = {
  showDescription: false,
  taxes: [],
  description: "",
  isRtl: false,
  isUseActionAvailable: false
};

const _default = /*#__PURE__*/React.memo(CodeDetailsHeading);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CodeDetailsHeading, "CodeDetailsHeading", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/CodeDetailsHeading/CodeDetailsHeading.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/CodeDetailsHeading/CodeDetailsHeading.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();